import { Button } from "@mui/material";

const FileUploader = (props: any) => {
    return (
        <Button>
            {props.type}Upload
            <input
                type="file"
                accept="application/pdf"
                onChange={(e) => props.uploadFile(e, props.type, props.detail)}
                style={{
                    opacity: 0,
                    appearance: "none",
                    position: "absolute",
                    width: '100%',
                    height: '100%'
                }}
            />
        </Button>
    );
};

export default FileUploader;